import React from 'react';
import cx from 'classnames';
import styles from './AlertCard.module.scss';
import AlertCardProps, { AlertTypeValues } from './AlertCard.types';
import Heading from '../../atoms/Heading';

const AlertCard = ({ className, heading, children, type = AlertTypeValues.Default }: AlertCardProps) => {
  return (
    <>
      {type === AlertTypeValues.Alert ? (
        <div className={cx(styles.card, className)}>
          <Heading className={styles.heading}>{heading}</Heading>
          {children}
        </div>
      ) : (
        <div className={cx(styles.cardDefault, className)}>
          <Heading className={styles.headingDefault}>{heading}</Heading>
          {children}
        </div>
      )}
    </>
  );
};

export default AlertCard;
